import { Component, inject } from '@angular/core';
import { ForwarderCapacityService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ForwarderCapacityCreateDto,
  ForwarderCapacityDto,
  ForwarderCapacityExcelDownloadDto,
  ForwarderCapacityUpdateDto,
} from '../proxy/general/dtos/forwarder-capacity';
import { FORWARDERCAPACITY_CONFIG, FORWARDERCAPACITY_FIELDS } from './forwarder-capacity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forwarder-capacity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ForwarderCapacityService, ConfirmationService],
  templateUrl: './forwarder-capacity.html',
  styleUrl: './forwarder-capacity.scss',
})
export class ForwarderCapacity extends BaseHierarchicalCrudComponent<
  ForwarderCapacityDto,
  ForwarderCapacityCreateDto,
  ForwarderCapacityUpdateDto,
  ForwarderCapacityExcelDownloadDto
> {
  service = inject(ForwarderCapacityService);
  config = FORWARDERCAPACITY_CONFIG;
  fields = FORWARDERCAPACITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForwarderCapacityDto): ForwarderCapacityUpdateDto {
    return {
      capacity: data.capacity,
      validSince: data.validSince,
      forwarderId: data.forwarderId,
      speciesId: data.speciesId,
      lengthId: data.lengthId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ForwarderCapacity';
  }
}
